import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.52864 12.4714C5.78899 12.7318 6.2111 12.7318 6.47145 12.4714L10.4714 8.47143C10.7318 8.21108 10.7318 7.78897 10.4714 7.52862L6.47145 3.52862C6.2111 3.26827 5.78899 3.26827 5.52864 3.52862C5.26829 3.78897 5.26829 4.21108 5.52864 4.47143L9.05723 8.00002L5.52864 11.5286C5.26829 11.789 5.26829 12.2111 5.52864 12.4714Z"
      fill={fill}
    />
  </svg>
);

export default Icon;
